import axios from 'axios'
import { useQuery } from 'react-query'

import { baseUrl } from 'configs/api'

import type { CommonResponse, CommonListResponse } from 'types/api'
import type { Playlists, PlaylistVideo, Tags } from 'types/video-inspirasi'

const basePath = `${baseUrl}/microlearnings`

export function useGetPlaylists() {
  return useQuery(
    [`${basePath}/video-playlists`],
    async (): Promise<CommonListResponse<Playlists>> => {
      try {
        const response = await axios.get<CommonListResponse<Playlists>>(
          `${basePath}/video-playlists`
        )
        return response.data
      } catch (e) {
        // eslint-disable-next-line no-console
        console.log(e)
      }
    },
    {
      useErrorBoundary: false,
    }
  )
}

export interface PlaylistByIdResponse extends Playlists, Tags {
  videos: PlaylistVideo[]
}

export function useGetPlaylistById(id: string) {
  return useQuery(
    [`${basePath}/video-playlists/${id}`],
    async (): Promise<CommonResponse<PlaylistByIdResponse>> => {
      try {
        const response = await axios.get<CommonResponse<PlaylistByIdResponse>>(
          `${basePath}/video-playlists/${id}`
        )
        return response.data
      } catch (e) {
        // eslint-disable-next-line no-console
        console.log(e)
      }
    },
    {
      enabled: !!id,
      useErrorBoundary: false,
    }
  )
}
